import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _capitalize from 'lodash/capitalize';
import PropTypes from 'prop-types';
// Core components
import Select from 'components/core/Select';
// Models
import { weekDaysLocalized } from 'models/planning';

const WeekSelectField = ({ labelId, value, onChange }) => (
  <Select
    label={<LocalizedMessage id={labelId} />}
    value={value}
    items={
      _map(weekDaysLocalized(), (day) => ({
        key: _toString(day.id),
        value: day.id,
        label: _capitalize(day.label),
      }))
    }
    onChange={onChange}
  />
);

WeekSelectField.propTypes = {
  labelId: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

module.exports = WeekSelectField;



// WEBPACK FOOTER //
// ./components/inputFields/WeekSelectField.js